module.exports = __webpack_public_path__ + "img/thumb-009.0b2b9893.png";